module.exports = __webpack_public_path__ + "static/media/rc.4c56044a.png";